export enum PbRequest {
    FETCH_ACCOUNTING_AREA_DEFAULTS,
    FETCH_SUPPORTED_TENANTS,
    FETCH_APPLIANCE_DEFAULTS,
    POST_INVITE_FOR_ACCOUNTING_AREA,
    FETCH_INVITES_FOR_ACCOUNTING_AREA,
    DELETE_INVITE_FOR_ACCOUNTING_AREA,
    FETCH_APPLIANCES,
    CREATE_APPLIANCE,
    UPDATE_APPLIANCE,
    DELETE_APPLIANCE,
    START_INSTALLATION_VERIFICATION,
    CANCEL_INSTALLATION_VERIFICATION,
    LOGIN,
    CHANGE_EMAIL,
    CONFIRM_CHANGE_EMAIL,
    GET_CHANGE_EMAIL,
    GET_COUNTRIES_DETAILS,
    GET_COUNTRIES,
    GET_APALEO_PROPERTY_LIST,
    PUT_APALEO_PROPERTY,
    GET_LOCATION_COSTS,
    SET_LOCATION_COSTS,
    POST_USE_SUGGESTED_COST_INCREASE,
    DELETE_REMOVE_SCHEDULED_COST,
    GET_LOCATION,
    GET_LOCATIONS_BY_MANSION,
    REMOVE_LOCATION,
    GET_ALL_LOCATIONS_FOR_ACCOUNTING_AREA,
    CREATE_LOCATION,
    UPDATE_LOCATION,
    REQUEST_CONNECTIVITY_CHECK,
    GET_MANAGER_ACVIVATION_INFORMATION,
    POST_MANAGER_ACTIVATION_AND_SET_PASSWORD,
    UPDATE_MANSION,
    LOAD_MANSIONS,
    CREATE_MANSION,
    REMOVE_MANSION,
    GET_OBJECT_STATS,
    GET_OPERATIONAL_CONTACTS,
    PUT_OPERATIONAL_CONTACT,
    POST_OPERATIONAL_CONTACT,
    DELETE_OPERATIONAL_CONTACT,
    PUT_ALL_MANSIONS_REQUEST,
    PUT_ASSIGN_OPERATIONAL_CONTACTS_TO_MANSION_REQUEST,
    PLACE_ORDER_BY_MAIL,
    GET_CONTRACTUAL_CONTACT,
    PUT_CONTRACTUAL_CONTACT,
    GET_CREDIT_NOTE_RECIPIENT,
    PUT_CREDIT_NOTE_RECIPIENT,
    LOAD_PARTNER_INVOICES,
    GET_PARTNER_MANAGER_DETAILS,
    GET_PARTNERS,
    GET_SPECIFIC_PARTNER,
    PATCH_PARTNER_MANAGER_DETAILS,
    CREATE_PARTNER_REQUEST,
    GET_PARTNER_BY_LOCATION_ID,
    GET_PROPERY_LINK_INFO_REQUEST,
    SEND_EMAIL_FOR_PROPERTY_LINK_REQUEST,
    REGISTRATION_REQUEST,
    ACTIVATION_REQUEST,
    RESEND_CODE_REQUEST,
    GET_SWITCH_SERIAL_NUMBERS,
    TURNOVER_LOAD_YEARS,
    TURNOVER_LOAD_MONTHS,
    GET_USAGE_DATA_SUBSCRIPTION,
    PUT_USAGE_DATA_SUBSCRIPTION,
    GET_USAGE_REPORT,
    GET_USAGE_PERIODS,
    FETCH_SETTLEMENT_BILLING_DETAILS,
    FETCH_CONTRACT_DETAILS,
    UPDATE_SETTLEMENT_BILLING_DETAILS,
    UPDATE_CONTRACT_DETAILS,
    CONFIRM_VATIN_REQUEST,
    GET_USER_DATA,
    POST_ADD_VIP_USERS,
    GET_VIP_USERS_IN_LAUNDRY_ROOM,
    DELETE_VIP_USERS_IN_LAUNDRY_ROOM,
    GET_LOCATION_VIP_PRICING,
    POST_LOCATION_VIP_PRICING,
    GET_INSTALLATION_LINK,
    EXTEND_INSTALLATION_LINK,
    REVOKE_INSTALLATION_LINK,
    CREATE_INSTALLATION_LINK,
    SEND_INSTALLATION_LINK,
    GET_ROUTER_SERIAL_NUMBERS,
    GET_CONNECTED_SWITCH_SERIAL_NUMBERS,
    GET_PHONE_USERS_FOR_LOCATION,
    DELETE_PHONE_USER_FOR_LOCATION,
    ADD_PHONE_USER_FOR_LOCATION,
}
